import { addComponentKeysets } from '../../../i18n';
import en from './en.json';
import ru from './ru.json';
const COMPONENT = 'Toaster';
export default addComponentKeysets({
    en,
    ru,
}, COMPONENT);
